import "./custom.css";
import React, { useEffect } from 'react'
import { saveConfig } from "./redux/configSlice";
import { saveUserData } from "./redux/userSlice";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiBaseUrlSSO, applicationId, redirectUrl } from './env';
import axios from 'axios';
import Loader from './Loader';
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import { Logout, redirectSSO } from './utils';
import Approuter from './components/Approuter';
import { myApplicationList } from "../redux/applicationSlice";


function App() {
    
    const [loading, setLoading] = useState(true);
    
    const dispatch = useDispatch();

      const fetchApplication = async (token) => {
    try {
      var { data } = await axios.get(`${apiBaseUrlSSO}/api/application/mine`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("data.data")
      console.log(data.data)
      dispatch(myApplicationList(data.data));


    } catch (error) {
      console.log(error);
    }
  };

    const getUserDetail = async (config) => {
        const urlParams = new URLSearchParams(window.location.search);
        const signOnUrl = config.redirectUrl || redirectUrl;
        const _tokenParam = urlParams.get("referrer");
        let token;
        if (_tokenParam) {
            const decoded = jwtDecode(_tokenParam);
            localStorage.setItem("token", decoded.token);
            token = decoded.token;
        } else if (localStorage.getItem("token")) {
            token = localStorage.getItem("token");
        } else {
            const currentURL = window.location.href;
            const baseUrl = new URL(currentURL).origin;
            const payload = {
                origin: baseUrl,
            };
            const referrer = jwtEncode(payload, "");
            return (window.location.href = `${signOnUrl}?referrer=${referrer}`);
        }
        try {
            var response = await axios.get(`${config?.ssoUrl}/api/user/me`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response?.status === 200) {
                localStorage.setItem("token", response?.data?.data?.token);
                const data = {
                    token: response?.data?.data?.token,
                    user: response?.data?.data?.user,
                };
                fetchApplication(response?.data?.data?.token);
                dispatch(saveUserData(data));
                setLoading(false);
            }
        } catch (error) {
            await Logout(token , signOnUrl);
        }
    };

    const getConfiguration = async () => {
        await axios
            .get(`${apiBaseUrlSSO}/api/application/configuration/${applicationId}`)
            .then((response) => {
                const data = response?.data?.data?.data;
                dispatch(saveConfig({ data }));
                getUserDetail(data)
            })
            .catch((err) => {
                console.log("err");
                console.log(err);
                redirectSSO();
            });
    };

    useEffect(() => {
        getConfiguration();
    }, []);
    if (loading) return <div><Loader /></div>
    return (
        <div>
            <Approuter />
        </div>
    )
}

export default App